<template>
    <v-col class="pa-0">
        <v-card :class="{'elevation-0': dialog}" class="round-card background-2">
            <v-card-title class="pa-3">
                <template>
                    <v-row class="pa-0 ma-0">
                        <v-col class="pa-0 ma-0 d-flex">
                            <div class="pl-2 pl-xl-3 ma-auto" style="white-space: nowrap;">Registro</div>
                            <v-divider class="mx-4 ma-auto hidden-xs-only" style="min-height: 22px;" vertical></v-divider>                            
                            <v-tabs v-model="tab" class="tabs-pill" :show-arrows="false" background-color="background-2" :mobile-breakpoint="0" hide-slider height="40">
                                <v-tab :key="1" class="secondary-tab" v-if="showComments">Commenti</v-tab>
                                <v-tab :key="2" class="secondary-tab" v-if="canShowAudits">Cronologia</v-tab>
                            </v-tabs>        
                        </v-col>
                    </v-row>                    
                </template>
                <v-spacer></v-spacer>
                <v-text-field class="hidden-xs-only font-weight-regular" v-show="expand && tab == 0 && showComments"
                    append-icon="search"
                    label="Cerca"
                    v-model="search"
                    clearable
                    hide-details
                    outlined
                    dense
                ></v-text-field>
                <v-tooltip top>
					<template v-slot:activator="{ on }">							
                        <v-btn :class="{'ml-3': $vuetify.breakpoint.smAndUp, 'ml-0': $vuetify.breakpoint.smAndDown}"  @click="getData()" :loading="loaderButton" v-on="on" icon>
                            <v-icon>mdi-refresh</v-icon>
                        </v-btn>
					</template>
                    <span>Refresh</span>
                </v-tooltip>
                <v-tooltip top>
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" @click="expand = !expand" icon>
                            <v-icon>{{ expand ? 'expand_less' : 'expand_more' }}</v-icon>
                        </v-btn>
                    </template>                    
                    <span>{{ expand ? 'Contrai' : 'Espandi' }}</span>
                </v-tooltip>
            </v-card-title>            
            <v-divider v-if="!dialog && expand"></v-divider>
		    <v-container class="py-0" fluid v-show="expand && tab == 0 && showComments">
                <v-row class="ma-0">
				    <v-col cols="12" class="pa-3">
                        <v-text-field class="hidden-sm-and-up"
                            append-icon="search"
                            label="Cerca"
                            v-model="search"
                            clearable
                            hide-details
                            outlined
                            dense
                        ></v-text-field>
                    </v-col>
                </v-row>
            </v-container>
            <v-expand-transition>

                <v-tabs-items v-model="tab" touchless dense>
                    <v-tab-item :key="1" v-if="showComments">

                        <div v-if="showNoteEditor && expand" class="px-4 pt-0 pb-4 background-2">
                            <div class="d-flex align-center justify-space-between mb-2">
                                <span class="caption grey--text text--darken-1">Descrizione</span>
                                <v-btn x-small color="success" depressed :loading="noteSaving" @click="saveNote()">
                                    <v-icon x-small left>mdi-content-save</v-icon>
                                    Salva
                                </v-btn>
                            </div>
                            <vue-editor
                                v-model="noteValue"
                                :editorOptions="editorSettings"
                                :editorToolbar="customToolbar"
                                useCustomImageHandler
                                @image-added="handleImageAdded"
                            ></vue-editor>
                        </div>
                        <v-divider v-if="showNoteEditor && expand"></v-divider>

                        <v-container class="pa-0 background-2 round-card-b" fluid v-show="expand">
                            <v-expand-transition>

                                <v-data-iterator
                                    v-show="expand"
                                    :items="comments"
                                    :options.sync="commentsPagination"
                                    :server-items-length="commentsTotalItems"
                                    column
                                    class="lg10">
                                    <template v-slot:no-data>
                                        <div class="text-center w100p">
                                            <v-card class="background-2 fs12i py-0 mx-4" elevation="0">
                                                <v-card-text class="caption text-center pb-4 pt-6">Nessun Commento</v-card-text>
                                                <v-card-text class="text-center pt-1"></v-card-text>
                                            </v-card>
                                        </div>
                                        <v-divider></v-divider>
                                    </template>

                                    <template v-slot:header>
                                        <v-row class="ma-0">
                                            <v-col cols="11" lg="11" offset-lg="1" class="comment pa-0">
                                                <v-timeline class="comment" dense clipped :class="{'mobile-timeline': $vuetify.breakpoint.mdAndDown}">
                                                    <v-timeline-item
                                                        fill-dot
                                                        medium>
                                                        <template v-slot:icon>
                                                            <v-avatar v-if="$store.getters.getProfile.avatar"
                                                                class="custom-avatar"
                                                                :size="39" 
                                                                v-ripple
                                                                :style="{'background-image': 'url(' + $store.getters.getProfile.avatar + ')'}">
                                                            </v-avatar>
                                                            <v-avatar v-else :class="$eventBusUtility.bgColor($store.getters.getProfile.id)" :size="38">
                                                                <span class="white--text fs14" style="line-height: 2">{{ $store.getters.getProfile.name.charAt(0) }}</span>
                                                            </v-avatar>
                                                        </template>
                                                        <v-row class="ma-0">
                                                            <v-col cols="12" class="pt-0 col-lg-11" :class="$vuetify.breakpoint.mdAndDown ? 'px-0' : ''" style="display: flex; flex-direction: row; width: 100%;">
                                                                <editor-mention class="w100p"
                                                                    ref="commentEditor"
                                                                    v-model="input"
                                                                ></editor-mention>
                                                                <v-btn v-show="input" class="ml-2 ma-auto" small icon @click="comment">
                                                                    <v-icon class="fs22i">send</v-icon>
                                                                </v-btn>                                            
                                                            </v-col>
                                                        </v-row>
                                                    </v-timeline-item>
                                                </v-timeline>
                                            </v-col>
                                        </v-row>
                                    </template>
                                    <template v-slot:item="props">
                                        <v-row class="ma-0">
                                            <v-col cols="10" sm="11" lg="10" offset-lg="1" class="pa-0">
                                                <v-timeline dense clipped class="pt-0" :class="{'mobile-timeline': $vuetify.breakpoint.mdAndDown}">
                                                    <v-scroll-y-transition group>
                                                        <v-timeline-item :key="props.item.id"
                                                            class="ma-0 pb-0"
                                                            color="transparent"
                                                            small>
                                                            <template v-slot:icon>
                                                                <v-avatar v-if="$store.getters.users[props.item.user_id] != undefined && $store.getters.users[props.item.user_id].avatar"
                                                                    class="custom-avatar"
                                                                    :size="18" 
                                                                    v-ripple
                                                                    :style="{'background-image': 'url(' + $store.getters.users[props.item.user_id].avatar + ')'}">
                                                                </v-avatar>
                                                                <v-avatar v-else :class="$eventBusUtility.bgColor(props.item.user_id)" :size="18">
                                                                    <span class="white--text fs12" v-if="props.item.creator">{{ props.item.creator.charAt(0) }}</span>
                                                                </v-avatar>
                                                            </template>
                                                            <v-row class="ma-0" justify="space-between">
                                                                <template v-if="textInEdit && commentId == props.item.id">
                                                                    <v-col cols="11" class="pa-0 display-auto" :class="!$vuetify.breakpoint.mdAndDown ? 'pl-2' : ''">
                                                                        <editor-mention
                                                                            v-model="textInEdit"
                                                                        ></editor-mention>
                                                                    </v-col>
                                                                    <v-col cols="1" class="pa-0 pl-2 ma-auto">
                                                                        <v-btn class="ma-auto" small icon @click="updateComment(props.item)"><v-icon class="fs22i" color="success">mdi-check-circle-outline</v-icon></v-btn>
                                                                        <v-btn class="ma-auto" small icon @click="cancel()"><v-icon class="fs22i" color="error">mdi-close-circle-outline</v-icon></v-btn>
                                                                    </v-col>  
                                                                </template>
                                                                <template v-else>
                                                                    <template v-if="$vuetify.breakpoint.mdAndUp">
                                                                        <v-col cols="9" class="fs12 ma-auto" style="margin-left: 0">
                                                                            <div class="comment-author">{{ props.item.creator }}</div>
                                                                            <span v-html="props.item.text"></span>
                                                                        </v-col>
                                                                        <v-col cols="3" class="capitalize fs11 grey--text mr-0 ma-auto text-right">{{ formatCreateDate(props.item.created_at) }}</v-col>
                                                                    </template>
                                                                    <template v-else>
                                                                        <v-col cols="9" class="fs11 pa-0 ma-auto py-1 ml-0">
                                                                            <div class="comment-author">{{ props.item.creator }}</div>
                                                                            <span v-html="props.item.text"></span>
                                                                        </v-col>
                                                                        <v-col cols="3" class="capitalize fs10 grey--text pa-0 mr-0 text-right ma-auto" v-html="formatSmallCreateDate(props.item.created_at)"></v-col>
                                                                    </template>
                                                                </template>
                                                            </v-row>
                                                        </v-timeline-item>
                                                    </v-scroll-y-transition>
                                                </v-timeline>
                                            </v-col>
                                            <v-col cols="2" sm="1" lg="1" class="ma-auto text-center pa-0">
                                                <template v-if="$vuetify.breakpoint.mdAndUp && !dialog">
                                                    <v-tooltip v-if="canReplyComment(props.item)" top>
                                                        <template v-slot:activator="{ on }">
                                                            <v-btn v-on="on" class="ma-a mr-0 mt-0" small text icon @click="replyComment(props.item)">
                                                                <v-icon class="fs22i">mdi-reply-outline</v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <span>Rispondi</span>
                                                    </v-tooltip>
                                                    <template v-if="canManageComment(props.item)">
                                                        <v-tooltip top>
                                                            <template v-slot:activator="{ on }">
                                                                <v-btn v-on="on" class="ma-a mr-0 mt-0" small text icon @click="editComment(props.item)">
                                                                    <v-icon class="fs22i">mdi-pencil</v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>Modifica</span>
                                                        </v-tooltip>
                                                        <v-tooltip top>
                                                            <template v-slot:activator="{ on }">
                                                                <v-btn v-on="on" class="ma-a ml-0 mt-0" small text icon @click="deleteComment(props.item.id)">
                                                                    <v-icon class="fs22i">mdi-delete-outline</v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>Elimina</span>
                                                        </v-tooltip>
                                                    </template>
                                                </template>
                                                <v-menu v-else-if="canReplyComment(props.item) || canManageComment(props.item)" bottom left>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn v-on="on" class="ma-a ml-0 mt-0" color="grey" text icon><v-icon class="fs22i">mdi-dots-vertical</v-icon></v-btn>
                                                    </template>
                                                    <v-list dense>
                                                        <v-list-item v-if="canReplyComment(props.item)" @click="replyComment(props.item)">
                                                            <v-list-item-title>Rispondi</v-list-item-title>
                                                        </v-list-item>
                                                        <template v-if="canManageComment(props.item)">
                                                            <v-list-item @click="editComment(props.item)">
                                                                <v-list-item-title>Modifica</v-list-item-title>
                                                            </v-list-item>
                                                            <v-list-item @click="deleteComment(props.item.id)">
                                                                <v-list-item-title>Elimina</v-list-item-title>
                                                            </v-list-item>
                                                        </template>
                                                    </v-list>
                                                </v-menu>
                                            </v-col>
                                        </v-row>
                                    </template>
                                    

                                    <template v-slot:footer.page-text="{ pageStart, pageStop, itemsLength }">
                                        Da {{ pageStart }} a {{ pageStop }} di {{ itemsLength }}
                                    </template>
                                </v-data-iterator>
                            </v-expand-transition>
                            <v-divider v-if=dialog></v-divider>
                        </v-container>
                    </v-tab-item>

                    <v-tab-item :key="2" v-if="canShowAudits">
                        <v-container class="pa-0 background-2 round-card-b" fluid v-show="expand">
                            <v-data-iterator
                                :items="audits"
                                :options.sync="auditsPagination"
                                :server-items-length="auditsTotalItems"
                                column
                                class="lg10"
                                >
                                <template v-slot:no-data>
                                    <div class="text-center w100p">
                                        <v-card class="background-2 fs12i py-0 mx-4" elevation="0">
                                            <v-card-text class="caption text-center pb-4 pt-6">Nessuna Attività</v-card-text>
                                            <v-card-text class="text-center pt-1"></v-card-text>
                                        </v-card>
                                    </div>
                                    <v-divider></v-divider>
                                </template>

                                <template v-slot:header>
                                    <v-row class="ma-0">
                                        <v-col cols="11" lg="11" offset-lg="1" class="comment pa-0">
                                            <v-timeline class="comment" dense clipped :class="{'mobile-timeline': $vuetify.breakpoint.mdAndDown}">
                                                <v-timeline-item
                                                    medium>
                                                    <template v-slot:icon>
                                                            <v-avatar color="primary" :size="18">
                                                                <v-icon class="white--text">mdi-history</v-icon>
                                                            </v-avatar>
                                                        </template>
                                                    <v-row class="ma-0" style="max-height: 45px">
                                                        <v-subheader class="font-weight-bold">Ultime Modifiche</v-subheader>

                                                    </v-row>
                                                </v-timeline-item>
                                            </v-timeline>
                                        </v-col>
                                    </v-row>
                                </template>
                                <template v-slot:item="props">
                                    <v-row class="ma-0">
                                        <v-col cols="11" offset-lg="1" class="pa-0">
                                            <v-timeline 
                                                dense
                                                clipped
                                                class="pt-0"
                                                :class="{'mobile-timeline': $vuetify.breakpoint.mdAndDown}">
                                                <v-scroll-y-transition group>
                                                    <v-timeline-item :key="props.item.id"
                                                        class="ma-0 pb-0"
                                                        color="transparent"
                                                        small>
                                                        <template v-slot:icon>
                                                            <v-avatar v-if="$store.getters.users[props.item.user_id] != undefined && $store.getters.users[props.item.user_id].avatar"
                                                                class="custom-avatar"
                                                                :size="18" 
                                                                v-ripple
                                                                :style="{'background-image': 'url(' + $store.getters.users[props.item.user_id].avatar + ')'}">
                                                            </v-avatar>
                                                            <v-avatar v-else :class="$eventBusUtility.bgColor(props.item.user_id)" :size="18">
                                                                <span class="white--text fs12" v-if="props.item.creator">{{ props.item.creator.charAt(0) }}</span>
                                                            </v-avatar>
                                                        </template>
                                                        <v-row class="ma-0" justify="space-between">
                                                            <template v-if="$vuetify.breakpoint.mdAndUp">
                                                                <v-col cols="9" class="fs12" style="margin: auto; margin-left: 0" v-html="isActivity(props.item) ? formatActivityText(props.item) : formatAuditText(props.item)"></v-col>
                                                                <v-col cols="3" class="capitalize fs11 grey--text mr-0 text-right" style="margin: auto">{{ formatCreateDate(props.item.created_at) }}</v-col>
                                                            </template>
                                                            <template v-else>
                                                                <v-col cols="9" class="fs11 pa-0 py-1" style="margin: auto; margin-left: 0" v-html="isActivity(props.item) ? formatActivityText(props.item) : formatAuditText(props.item)"></v-col>
                                                                <v-col cols="3" class="capitalize fs10 grey--text pa-0 mr-0 text-right" style="margin: auto" v-html="formatSmallCreateDate(props.item.created_at)"></v-col>
                                                            </template>
                                                        </v-row>
                                                    </v-timeline-item>
                                                </v-scroll-y-transition>
                                            </v-timeline>
                                        </v-col>
                                    </v-row>
                                </template>
                                <template v-slot:footer.page-text="{ pageStart, pageStop, itemsLength }">
                                    Da {{ pageStart }} a {{ pageStop }} di {{ itemsLength }}
                                </template>
                            </v-data-iterator>
                            <v-divider v-if=dialog></v-divider>
                        </v-container>
                    </v-tab-item>
                </v-tabs-items>         

            </v-expand-transition>
        </v-card>
    </v-col>
</template>

<script>
import InputMixin from '@/mixins/InputMixin'
import EditorMention from '@/components/common/EditorMention'

export default {
	name: 'activities',
	mixins: [InputMixin],
	components: {
		EditorMention,
	},
	props: {
		modelClass: String,
		modelId: Number,
		modelDef: {
			type: String,
			default: ''
		},
		dialog: Boolean,
		showComments: {
			type: Boolean,
			default: true
		},
		noteField: {
			type: String,
			default: ''
		},
		model: {
			type: Object,
			default: null
		}
	},

	data() {
		return {
			audits: [],
			comments: [],
			input: '',
			search: '',
			loaderButton: false,
			commentsPagination: {'itemsPerPage': 5},
			commentsTotalItems: 0,
            auditsPagination: {'itemsPerPage': 5},
			auditsTotalItems: 0,
			debounceUnwatch: {},
			textInEdit: null,
            commentId: null,
            expand: true,
            tab: null,
            noteValue: '',
            noteSaving: false,
		}
	},

	watch: {
		auditsPagination: {
			handler(newValue, oldValue) {
				if(newValue.auditsTotalItems == oldValue.auditsTotalItems) {
					this.getAudits()
				}
			},
			deep: true,
		},
        
        commentsPagination: {
			handler(newValue, oldValue) {
				if(this.showComments && newValue.commentsTotalItems == oldValue.commentsTotalItems) {
					this.getComments()
				}
			},
			deep: true,
		},

        // search: {
		// 	handler(newValue, oldValue) {
        //         this.debounceUnwatch()
        //     },
        // }
	},

	computed: {
		formatCreateDate(date) {
			return (date) => {
				return moment(date).format('LLLL')
			}
		},

		formatSmallCreateDate(date) {
			return (date) => {
				return moment(date).format('DD/MM/YY <br> H:m')
			}
		},

		isErasable(erasable) {
			return (erasable) => {
				return erasable == 1 ? true : false
			}
		},

		isEditable(editable) {
			return (editable) => {
				return editable == 1 ? true : false
			}
		},

        canManageComment() {
            return (item) => {
                return !this.$store.getters.checkSettings('hide_comments_actions')
                    && item.user_id == this.$store.getters.getProfile.id
                    && this.isErasable(item.erasable)
                    && this.isEditable(item.editable)
            }
        },

        // Senza l'utente nello store la menzione non avrebbe un id da notificare
        canReplyComment() {
            return (item) => {
                return item.user_id != this.$store.getters.getProfile.id
                    && this.$store.getters.users[item.user_id] != undefined
            }
        },

        showNoteEditor() {
            return this.noteField && this.modelDef && this.$store.getters.checkSettings('edit_activities_note_' + this.modelClass.toLowerCase())
        },

        hideAudits() {
            return this.$store.getters.checkSettings('hide_audits')
        },

        // Le permission dei ruoli sono salvate con la chiave "pulita" (es.
        // saleinvoices): le rotte dei documenti passano invece modelDef nella
        // forma documents-{doctype}, che va usata cosi' com'e' per le chiamate
        // API ma non come chiave di permission.
        permissionKey() {
            if(!this.modelDef) return null
            return this.modelDef.startsWith('documents-') ? this.modelDef.replace('documents-', '') : this.modelDef
        },

        canShowAudits() {
            return this.permissionKey && this.$store.getters.checkRolePermissions(
                this.permissionKey,
                'audit') && !this.hideAudits
        },

        isActivity() {
            return (item) => {
                return item.record_type === 'activity'
            }
        },
        
        formatActivityText() {
            return (activity) => {
                // If creator exists, wrap it in a styled span
                const creator = activity.creator 
                    ? `<span class="text-decoration-underline">${activity.creator}</span> `
                    : ''
                
                // Return the formatted activity text
                return `${creator}${activity.activity_text}`
            }
        },

        formatAuditText() {
            return (audit) => {
                let text = '';
                // Check if this is a system-generated audit
                const isSystemAudit = audit.is_system || audit.creator === 'system';
                const creator = isSystemAudit 
                    ? `<span class="text-decoration-underline">Il sistema</span>`
                    : `<span class="text-decoration-underline">${audit.creator}</span>`;
                
                // Funzione helper per formattare i valori in base al tipo
                const formatValue = (value, type) => {
                    if (value === null || value === undefined) return 'vuoto'
                    if (value === 0) return '0'
                    if (value === '') return 'vuoto'

                    // Gestisci i vari tipi di campo
                    if (type === 'currency') {
                        // Convertire il valore in formato valuta
                        return this.$options.filters.currency(value)
                    }
                    return value
                };

                // row_label arriva solo sugli audit delle righe collegate (prodotti del
                // documento): senza il nome sarebbero indistinguibili dalle modifiche di
                // testata e una riga per prodotto renderebbe la cronologia illeggibile.
                // Il nome e' inserito dall'utente e finisce in v-html, quindi va escapato.
                const escapeHtml = (value) => String(value)
                    .replace(/&/g, '&amp;')
                    .replace(/</g, '&lt;')
                    .replace(/>/g, '&gt;')

                const rowLabel = audit.row_label ? escapeHtml(audit.row_label) : ''
                const target = rowLabel
                    ? `la riga: <span class="font-weight-medium font-italic">${rowLabel}</span>`
                    : 'il record'

                switch(audit.event) {
                    case 'created':
                        text = rowLabel
                            ? `${creator} <span class="font-weight-medium">Ha aggiunto ${target}</span>`
                            : `${creator} <span class="font-weight-medium">Ha creato un nuovo record</span>`;
                        if (Object.keys(audit.new_values).length > 0) {
                            text += `<br><span class="grey--text">Valori inseriti:</span><br>`;
                            for (const [key, field] of Object.entries(audit.new_values)) {
                                const formattedValue = formatValue(field.value, field.type);
                                text += `<span class="font-italic">- ${field.label}</span>: <span class="success--text">${formattedValue}</span><br>`;
                            }
                        }
                        break;
            
                    case 'updated':
                        text = `${creator} <span class="font-weight-medium">Ha modificato ${target}</span>`;
                        
                        // Check if there are any modified values at all
                        const hasModifiedValues = Object.keys(audit.new_values).length > 0 || Object.keys(audit.old_values).length > 0;
                        
                        if (hasModifiedValues) {
                            text += '<br>';
                            // If new_values is empty but old_values has entries, it means fields were cleared
                            if (Object.keys(audit.new_values).length === 0 && Object.keys(audit.old_values).length > 0) {
                                text += `<span class="grey--text">Valori modificati:</span><br>`;
                                for (const [key, oldField] of Object.entries(audit.old_values)) {
                                    const label = oldField.label || (audit.custom_field_names && audit.custom_field_names[key]) || key;
                                    const formattedOldValue = formatValue(oldField.value, oldField.type);
                                    text += `<span class="font-italic">- ${label}</span>: `;
                                    text += `<span class="error--text">${formattedOldValue}</span>`;
                                    text += ` <span class="grey--text">➞</span> `;
                                    text += `<span class="success--text">vuoto</span><br>`;
                                }
                            } else if (Object.keys(audit.new_values).length > 0) {
                                // Original behavior for regular updates
                                text += `<span class="grey--text">Valori modificati:</span><br>`;
                                for (const [key, newField] of Object.entries(audit.new_values)) {
                                    const oldField = audit.old_values[key] || { value: 'vuoto' };
                                    const fieldType = newField.type || oldField.type;
                                    
                                    const formattedOldValue = formatValue(oldField.value, fieldType);
                                    const formattedNewValue = formatValue(newField.value, fieldType);
                                    
                                    text += `<span class="font-italic">- ${newField.label}</span>: `;
                                    text += `<span class="error--text">${formattedOldValue}</span>`;
                                    text += ` <span class="grey--text">➞</span> `;
                                    text += `<span class="success--text">${formattedNewValue}</span><br>`;
                                }
                            }
                        }
                        break;
            
                    case 'deleted':
                        text = `${creator} <span class="font-weight-medium">Ha eliminato ${target}</span>`;
                        break;
            
                    default:
                        text = `${creator} <span class="font-weight-medium">Ha eseguito l'azione: ${audit.event}</span>`;
                }
            
                return text;
            };
        }
	},

	methods: {

        getData() {
            if (this.showComments) {
                this.getComments()
            }
            if(!this.hideAudits && this.canShowAudits) {
                this.getAudits()
            }
        },

		comment() {
			if(this.input) {

				let data = {
					text: this.input,
					commentable_id: this.modelId,
					commentable_type: this.modelClass,
					type: 'comment',
				}

				this.axios.post('/comments', data).then(response => {
					// get body data
					this.getComments()
					this.input = ''
					this.$eventBusUtility.$emit('inputEmpty')

				}, response => {
					// error callback
				})
			}
		},

		replyComment(comment) {
			const user = this.$store.getters.users[comment.user_id]
			const editor = this.$refs.commentEditor

			editor.insertMention({ id: user.id, value: user.value })
			editor.$el.scrollIntoView({ behavior: 'smooth', block: 'center' })
		},

		editComment(comment) {
			this.textInEdit = comment.text
			this.commentId = comment.id
		},

		updateComment(comment) {
			comment.text = this.textInEdit

			this.axios.put('/comments/' + comment.id, comment).then(response => {
				// get body data
				this.getComments()
				this.cancel()
				this.$eventBusUtility.$emit('inputEmpty')

				let snackmessage = ''
				let snackcolor = ''
				if(response.data.status == 'message'){
					snackmessage = response.data.message
					snackcolor = 'warning'
				} else{
					snackmessage = 'Commento aggiornato con successo'
					snackcolor = 'success'
                }
                
                this.$store.commit('setSnackbar', {timeout: 6000, text: snackmessage, value: true, color: snackcolor})
			}, response => {
				// error callback
			})
		},

		cancel() {
			this.textInEdit = null
			this.commentId = null
		},

		deleteComment(id) {
			this.axios.post('/comments/delete', {ids: [id]}).then(response => {
				// get body data
				this.getComments()
				let snackmessage = ''
				let snackcolor = ''
				if(response.data.status == 'message'){
					snackmessage = response.data.message
					snackcolor = 'warning'
				} else{
					snackmessage = 'Commento eliminato con successo'
					snackcolor = 'success'
				}
                    
				this.$store.commit('setSnackbar', {timeout: 6000, text: snackmessage, value: true, color: snackcolor})

			}, response => {
				// error callback
			})
		},

		getComments() {
			this.loaderButton = true
			let dataObject = {
				page: this.commentsPagination.page,
				per_page: this.commentsPagination.itemsPerPage,
				model_id: this.modelId,
				model_class: this.modelClass,
                type: 'comment',
                filter: this.search,
                sortBy: ['comments.created_at'],
                sortDesc: [true],
			}

            if(this.hideAudits) {
                delete dataObject.type
            } 
                
			this.axios.post('/comments-filters', dataObject).then(response => {
				// get body data
				this.comments = response.data.data.data
				this.commentsTotalItems = response.data.data.total
				setTimeout(() => {this.loaderButton = false}, 500)
                    
			}, response => {
				// error callback
			})
        },

        saveNote() {
            this.noteSaving = true
            this.axios.put(this.modelDef + '/' + this.modelId, { [this.noteField]: this.noteValue }).then(response => {
                this.noteSaving = false
                this.$store.commit('setSnackbar', {
                    timeout: 6000,
                    text: 'Note salvate con successo',
                    value: true,
                    color: 'success'
                })
            }, response => {
                this.noteSaving = false
                this.$store.commit('setSnackbar', {
                    timeout: 6000,
                    text: 'Errore durante il salvataggio delle note',
                    value: true,
                    color: 'error'
                })
            })
        },

        getAudits() {
			this.loaderButton = true
			let dataObject = {
				page: this.auditsPagination.page,
				per_page: this.auditsPagination.itemsPerPage,
				model_id: this.modelId,
				model_class: this.modelClass,
                filter: this.search,
                sortBy: ['created_at'],
                sortDesc: [true],
			}

            this.axios.post('/model-audits', dataObject).then(response => {
				// get body data
				this.audits = response.data.data.data
				this.auditsTotalItems = response.data.data.total
				setTimeout(() => {this.loaderButton = false}, 500)
                    
			}, response => {
				// error callback
			})
		},

	},

	created() {
		this.debounceUnwatch = this.$watch('search', _.debounce(() => {
            if(!this.hideAudits && this.canShowAudits && this.tab == 1) {
                this.getAudits()
            } else if(this.showComments && this.tab == 0) {
                this.getComments()
            }
        }, 700))

        if (this.modelClass && this.$store.getters.checkSettings('compact_' + this.modelClass + '_view')) {
            this.expand = false
        } else {
            this.expand = !this.$store.getters.checkSettings('compact_viewing')
        }

        // Se showComments è false, imposta il tab su Cronologia (tab index 0 perché Commenti è nascosto)
        if (!this.showComments) {
            this.tab = 0
        }

        if (this.showNoteEditor && this.model) {
            this.noteValue = this.model[this.noteField] || ''
        }
	},
}
</script>

<style>
    .v-timeline {
        padding-top: 8px !important;
        position: relative;
    }

    .v-timeline:hover {
        background: rgba(0,0,0,0.06)
    }

    .comment.pa-0 {
        overflow: visible !important;
    }

    .comment .v-timeline {
        overflow: visible !important;
    }

    .comment .v-timeline:before {
        top: 12px;
        height: auto !important;
        bottom: -1px;
    }

    .mobile-timeline > span > div > .v-timeline-item__body {
        max-width: calc(100% - 46px) !important;
    }

    .mobile-timeline > div > .v-timeline-item__body {
        max-width: calc(100% - 46px) !important;
    }
    .v-timeline:hover {
        background: transparent;
    }    
    .ql-mention-list-container {
        z-index: 999;
    }

    /* Aggiungi questi stili per migliorare la leggibilità */
    .audit-change {
        margin: 4px 0;
        padding: 2px 0;
    }

    /* Add styles for activity entries */
    .activity-entry {
        padding: 4px 0;
        margin-bottom: 4px;
    }

    .comment-author {
        font-weight: 700;
        font-size: 13px;
        color: var(--v-primary-base);
        margin-bottom: 2px;
    }

</style>
